import React from 'react';
import Script from 'next/script';
import { FullStory } from '../../../utils/fullStory';
import { googleTagManagerScript } from '@olo-web/utils/google/tagManager';
import { facebookPixelImageNoScript, facebookPixelScript } from '@olo-web/utils/facebook';
import { useMerchant, useMerchantGroup, useMerchantTheme } from '@domain/merchants/queries';
import { gtagScript } from '@olo-web/utils/google/analytics';
import { EMerchantPixelsAndKeys } from '@olo-web/types/enums/merchantPixelsAndKeys.enum';
import { isValidMerchantPixelId } from '@olo-web/utils/common/functions/isValidMerchantPixelId';

const gtmKey = process.env.NEXT_PUBLIC_GTM_KEY || '';
const appVersion = process.env.NEXT_PUBLIC_APP_VERSION || '';

export const Scripts = () => {
  const { data: theme } = useMerchantTheme();
  const { data: merchant } = useMerchant();
  const { data: group } = useMerchantGroup();
  const data = {
    merchantId: merchant?.merchantId,
    loyaltyEnabled: merchant?.spotOnLoyaltyEnabled,
    merchantName: group?.name,
    merchantLocation: merchant?.name,
    legacyRefactor: 'refactor',
    version: appVersion,
    orderTypesAvailable: merchant?.orderTypesAvailableAnalyticsString,
  };

  const googleTagManagerId = theme?.[EMerchantPixelsAndKeys.GOOGLE_TAG_MANAGER]?.trim();
  const googleAdWordsId = theme?.[EMerchantPixelsAndKeys.GOOGLE_ADWORDS_KEY]?.trim();
  const facebookPixelId = theme?.[EMerchantPixelsAndKeys.FACEBOOK_PIXEL]?.trim();

  const isGoogleTagManagerIdValid = isValidMerchantPixelId(
    EMerchantPixelsAndKeys.GOOGLE_TAG_MANAGER,
    googleTagManagerId
  );
  const isGoogleAdWordsIdValid = isValidMerchantPixelId(
    EMerchantPixelsAndKeys.GOOGLE_ADWORDS_KEY,
    googleAdWordsId
  );
  const isFacebookPixelIdValid = isValidMerchantPixelId(
    EMerchantPixelsAndKeys.FACEBOOK_PIXEL,
    facebookPixelId
  );

  return (
    <>
      <Script
        async
        id="googleTagManager"
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: googleTagManagerScript(gtmKey, data),
        }}
      />
      <FullStory />
      {isGoogleTagManagerIdValid && (
        <Script
          async
          id={`googleTagManager=${googleTagManagerId}`}
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: googleTagManagerScript(googleTagManagerId, data),
          }}
        />
      )}
      {isGoogleAdWordsIdValid && (
        <>
          <Script async src={`https://www.googletagmanager.com/gtag/js?id=${googleAdWordsId}`} />
          <Script
            async
            id="gtagScript"
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: gtagScript(googleAdWordsId),
            }}
          />
        </>
      )}
      {isFacebookPixelIdValid && (
        <>
          <Script
            async
            id="facebookPixelScript"
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: facebookPixelScript(facebookPixelId),
            }}
          />
          <noscript
            dangerouslySetInnerHTML={{
              __html: facebookPixelImageNoScript(facebookPixelId),
            }}
          ></noscript>
        </>
      )}
    </>
  );
};
